import defaultState from './state'
import mutations from './mutations'
import actions from './actions'

const reserveModal = {
  namespaced: true,
  state: {
    ...defaultState,
  },
  mutations,
  actions,
}

export default reserveModal



// WEBPACK FOOTER //
// ./src/store/reserveModal/index.js